var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoUkv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 973.1 199.1",
    style: {
      enableBackground: "new 0 0 973.1 199.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "155.3,43.9 192.9,43.9 192.9,102.2 232.7,43.9 274.3,43.9 226.3,108.2 275.4,189.9 233.2,189.9 204.1,137.6  192.9,152.4 192.9,189.9 155.3,189.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.2,189.9 306.5,189.9 279.3,43.9 320.3,43.9 334.3,160.8 347.4,43.9 388.1,43.9  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.6,43.9h59.8c36.8,0,51.6,15.5,51.6,43.1v59.7c0,28.7-17.1,43.1-51.6,43.1h-59.8V43.9z M560,161.7 c13.3,0,18.4-5.9,18.4-17.4V89.6c0-11.5-6.1-17.2-18.4-17.2h-17.9v89.2H560z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "628.2,165.8 677.7,75.1 630.7,75.1 630.7,44.1 723.2,44.1 723.2,68.4 673.4,159.1 725.7,159.1 725.7,189.9  628.2,189.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744.9,
    y: 44.1,
    width: 37.8,
    height: 145.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.2,44.1h53.5l29.7,145.8h-40.9l-3.3-23.7h-24.7l-3,23.7h-40.6L828.2,44.1z M864.1,142.4l-9.3-68.9l-9.1,68.9H864.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.3,
    y: 44.1,
    width: 37.8,
    height: 145.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.3,
    y: 44.2,
    width: 36.9,
    height: 100.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6,7.2v36.9h12.7c20.4,0,36.9-16.5,36.9-36.9H46.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3,144.5c-6.6,5.9-15.3,9.5-24.9,9.5s-18.3-3.6-24.9-9.5l-26.1,26.1c13.3,12.6,31.3,20.3,51,20.3s37.7-7.7,51-20.3 L96.3,144.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.6,
    y: 44.2,
    width: 36.9,
    height: 100.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.6,7.2v36.9c20.4,0,36.9-16.5,36.9-36.9H662.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.1,44.1 486.7,44.1 486.7,72.6 437.6,72.6 437.6,103.2 474.9,103.2 474.9,130.9 437.6,130.9 437.6,161.7  486.7,161.7 486.7,189.9 400.1,189.9  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUkv);
export default __webpack_public_path__ + "static/media/logo_ukv.0721925f2ffbf1004ee42ead454cbbf2.svg";
export { ForwardRef as ReactComponent };